<template>
  <div>
    <div class="banner">
      <h4>{{ title }}</h4>
    </div>

    <AlertError class="mb-5" v-model="displayError" :resource="displayError" />

    <v-form @submit.prevent="create" ref="form"> 
      <v-text-field 
        class="rounded-lg" 
        color="#41916b"
        outlined 
        v-model="resource.name" 
        :rules="formRules" 
        dense>
          <template v-slot:label>
              Descrição<span style="color: red;">*</span>
          </template>
      </v-text-field>

      <v-card-actions class="cardFooter">
        <v-spacer></v-spacer>
          <v-btn class="rounded-lg" color="#e74c3c" text elevation="0" @click="closeDialog()">
            <span>{{$t('buttons.cancel')}}</span>
          </v-btn>

          <v-btn class="rounded-lg" color="blue" text elevation="0" @click="clearForm()">
            <span>{{$t('buttons.clean_up')}}</span>
          </v-btn>

          <v-btn class="rounded-lg" elevation="0" color="#41916b" type="submit" :loading="loading">
            <span class="textBtn">{{ btnMessage }}</span>
            <v-icon color="#FFFFFF" small class="ml-2">mdi-arrow-right</v-icon>
          </v-btn>
      </v-card-actions>
    </v-form> 
  </div>
</template>
  
<script>
import { saveComorbidity } from "@/service/basic-registrations/ComorbiditiesService";
import AlertError from "../alerts/Error-component.vue";
import Formatters from "@/utils/Formatters";
import { mapActions } from "vuex";
export default {
  data() {
    return {
        dialog: false, 
        formRules: [(v) => !!v || "Campo obrigatório."],
        displayError: {
          display: false,
          message: [],
        },    
        loading: false,
        options: {}, 
      };
  },

  props: { 
    resource: {
      type: Object,
    }
  },

  components: {
    AlertError,
  },

  watch: {  
    'resource':{
      handler(item){
        if(!item.id && this.$refs.form){
          this.$refs.form.resetValidation();
        } 
      },
      immediate: true,
    }
  },

  computed: {
    title() {
      return this.resource.id ? "Atualizar Comorbidade" : "Nova Comorbidade";
    },

    btnMessage() {
      return this.resource.id ? "Atualizar" : "Salvar";
    },
  },

  methods: {
    ...mapActions([
      "changeSnackBarData", 
    ]),
    
    create() {
      this.loading = true;
      if(this.$refs.form.validate()) { 
        const isEdit = !!this.resource.id;
        const dados = this.resource
              dados.name = this.resource.name.toUpperCase();

            saveComorbidity(isEdit ? this.resource.id : null, dados).then((response) => {
              this.loading = false; 
              this.changeSnackBarData({
                status: true,
                type: "success",
                titleMessage: response.data.message,
                bodyMessage: "",
                cardColor: "#41916b",
                titleIcon: "mdi-checkbox-marked-circle",
              });

              setTimeout(() => {
                this.closeDialog();
                this.closeSnackBar();
              }, 3000); 
          }).catch((err) => {
            this.loading = false;
            this.changeSnackBarData({
              status: true,
              type: "erro",
              titleMessage: "Algo deu errado!",
              bodyMessage: Formatters.formatErrorMessage(err),
              cardColor: "red",
              titleIcon: "mdi-close-circle",
            })

            setTimeout(() => {
              this.closeSnackBar();
            }, 3000);
          });   
      }
    },

    clearForm(){
      this.$refs.form.resetValidation();
      this.$refs.form.reset(); 
    },

    closeDialog() {
        this.$emit("closeDialog");
        this.$refs.form.resetValidation();
        this.$refs.form.reset();
        this.resource.crm = "";
        this.resource.name = ""; 
    },

    closeSnackBar() {
      this.changeSnackBarData({
        status: false,
        type: "",
        titleMessage: "",
        bodyMessage: "",
        cardColor: "",
        titleIcon: "",
      });
    } 
  }, 
};
</script>
  
<style scoped> 
.space {
  width: 15px;
} 
 
.textBtn {
  font-family: "Poppins";
  color: #ffffff;
}
 
.card {
  padding: 35px;
}

.banner {
  background: #b3ffab; 
  background: -webkit-linear-gradient(to right,
      #41916b,
      #1abc9c); 
  background: linear-gradient(to right,
      #41916b,
      #b8e0cd); 

  border-radius: 8px;

  margin-bottom: 20px;

  display: flex;
  align-items: center;
}

.banner>h4 {
  color: #ffffff;
  padding: 10px;
}

.cardFooter {
  padding: 0 !important;
}
</style>
  